import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a1a1a',
      light: '#484848',
      dark: '#000000',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c4a661',
      light: '#f7d78f',
      dark: '#937735',
      contrastText: '#000000',
    },
    background: {
      default: '#ffffff',
      paper: '#fafafa',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '3rem',
      fontWeight: 500,
    },
    h2: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h3: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '2rem',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h6: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: '1.1rem',
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.75,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.75,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '0.75rem 1.5rem',
          '&:hover': {
            backgroundColor: '#c4a661',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #eee',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
